export default __webpack_public_path__ + "images/0x160e07e42ADbC1FCE92D505B579Bcd8a3fBEa77d.png";